import { customerAddressFormStyles } from "@insite/content-library/Components/CustomerAddressForm";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(customerAddressFormStyles, {
    cancelButton: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            margin-right: 10px;
            text-transform: uppercase;
            border-radius: 22px;
            border: 1px solid ${COLORS.secondaryBtn};
            min-width: 120px;
            background: ${COLORS.white};
            color: ${COLORS.secondaryBtn};
            &:hover {
                background: ${COLORS.secondaryBg};
                border: 1px solid ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
                border: 1px solid ${COLORS.disabled.base};
            }
        `,
    },
    submitButton: {
        typographyProps: {
            size: TYPOGRAPHY.size.smaller,
            weight: TYPOGRAPHY.weight.bold,
        },
        css: css`
            text-transform: uppercase;
            border-radius: 22px;
            background-image: linear-gradient(to right, #44a8f7, ${COLORS.link.base});
            border: none;
            min-width: 120px;
            color: ${COLORS.white};
            & :hover {
                background: ${COLORS.secondaryBtn};
            }
            &:disabled:hover {
                background: ${COLORS.disabled.base};
            }
        `,
    },
});
